import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../../config.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BeneficiariesService {

    constructor(
        private http: HttpClient,
        private configService: ConfigService
    ) {}

    public getBeneficiaries(cardno = ''): Observable<any> {
        return this.http.get(`${this.configService.serverURL}/cards/get-beneficiaries?cardno=${cardno}`);
    }

    public addBeneficiary(payload: any): Observable<any> {
        // INB Action
        return this.http.post<any>(
            `${this.configService.serverURL}/cards/add-beneficiary`, payload
        );
    }

    public deleteBeneficiary(card: any): Observable<any> {
        // DLB Action
        // const payload = { cardno: card };
        return this.http.delete<any[]>(
            `${this.configService.serverURL}/cards/delete-beneficiary?cardno=${card}`,
        );
    }
}
